// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1cdG4","label":"styles_label__3Rgxe"};